import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const FIELDS = [
  { key: "first_name", label: "Given Name", required: true },
  { key: "last_name", label: "Family Name", required: true },
  { key: "email", label: "Email", type: "email", required: true },
  { key: "password", label: "Password", type: "password", required: true },
  { key: "date_of_birth", label: "Date of Birth", type: "date", required: true },
  { key: "band_registry_number", label: "Band Registry # (from your card)", required: true },
  { key: "treaty_status_number", label: "Treaty Status # (optional)" },
  { key: "parents_names", label: "Parents' Full Names (as on legacy file)" },
  { key: "community_of_residence", label: "Community of Residence" },
  { key: "phone", label: "Phone" },
];

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({});
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(form);
      nav("/pending");
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[85vh] px-6 py-16 flex items-center justify-center">
      <div className="w-full max-w-3xl corner-tick border border-white/12 bg-[color:var(--surface)] p-8 relative">
        <div className="absolute -top-3 left-6 bg-[color:var(--bg)] px-3 label-mono">Band registry application</div>
        <h1 className="font-display text-3xl mt-2">Request verified access</h1>
        <p className="text-white/60 text-sm mt-3 leading-relaxed max-w-2xl">
          Your submission is reviewed by the Band Registry Clerk against legacy records. Only approved
          applicants gain portal access. Provide information exactly as it appears on your registry file.
        </p>

        <form onSubmit={submit} className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {FIELDS.map((f) => (
            <div key={f.key} className={f.key === "email" || f.key === "password" || f.key === "parents_names" ? "sm:col-span-2" : ""}>
              <label className="label-mono block mb-2">{f.label}{f.required && <span className="text-[color:var(--signal)]"> *</span>}</label>
              <input
                type={f.type || "text"} required={!!f.required}
                value={form[f.key] || ""} onChange={(e)=>setForm({...form, [f.key]: e.target.value})}
                className="w-full px-3 py-2.5 text-sm"
                data-testid={`register-${f.key}-input`}
              />
            </div>
          ))}
          {err && <div className="sm:col-span-2 border border-[color:var(--signal)]/50 bg-[color:var(--signal)]/10 text-[color:var(--signal)] text-sm p-3" data-testid="register-error">{err}</div>}
          <div className="sm:col-span-2 flex flex-wrap items-center gap-4 pt-2">
            <button type="submit" disabled={loading} className="btn-cta primary" data-testid="register-submit-btn">
              {loading ? "Submitting…" : "Submit for verification"}
            </button>
            <Link to="/login" className="font-mono text-xs text-white/50 hover:text-white" data-testid="register-to-login">Already registered? Sign in →</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
